import {
  IconButton,
  Label
} from "@fluentui/react";
import { useEffect, useState } from "react";
interface IFooterTable {
  TotalData: number | undefined;
  TotalPagina: number | undefined;
  PaginaActual: number | undefined;
  onClickNext: () => void;
  onClickPrevius: () => void;
}

export const FooterTable = (props: IFooterTable) => {
  const [isNext, setIsNext] = useState(false);
  const [isPrevius, setIsPrevius] = useState(false);

  useEffect(() => {
    if (props.PaginaActual === 1) {
      setIsNext(true);
    } else {
      setIsNext(false);
    }
    if (props.PaginaActual === props.TotalPagina) {
      setIsPrevius(true);
    } else {
      setIsPrevius(false);
    }
  }, [props.PaginaActual]);

  return (
    <Label
      style={{ display: "flex", justifyContent: "end", alignItems: "center" }}
    >
      <IconButton
        disabled={isNext}
        onClick={() => {
          props.onClickPrevius();
        }}
        iconProps={{ iconName: "Previous" }}
      />{" "}
      Página {props.PaginaActual} de {props.TotalPagina}
      {""}
      <IconButton
        disabled={isPrevius}
        onClick={() => {
          props.onClickNext();
        }}
        iconProps={{ iconName: "Next" }}
      />
      | {props.TotalData} Registros encontrados
    </Label>
  );
};
